import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class ClassId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): ClassId {
    const regex = new RegExp(this.validationRule.pattern.value);
    if (!regex.test(value)) {
      throw new Error(this.validationRule.pattern.message);
    }
    return new ClassId(value);
  }

  /** キー */
  static get key(): string {
    return 'classId';
  }

  /** タイプ */
  static get type(): string {
    return 'text';
  }

  /** ラベル */
  static get label(): string {
    return 'クラスID';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return 'hiyoko';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
      /** パターン */
      pattern: {
        /** 値 */
        value: /^([a-zA-Z0-9.]){3,128}$/,
        /** メッセージ */
        message: '3文字以上かつ128文字以下かつアルファベット小文字、大文字、数字である必要があります',
      },
    };
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
